import mammoth from 'mammoth';

export async function extractTextFromDOCX(file: File): Promise<string> {
  try {
    const arrayBuffer = await file.arrayBuffer();
    const result = await mammoth.extractRawText({ arrayBuffer });
    const text = result.value.trim();
    
    return text || 'No text content could be extracted from the DOCX file';
  } catch (error) {
    console.error('DOCX extraction error:', error);
    return 'Error: Could not process DOCX file. Please try uploading a different file format (PDF or TXT).';
  }
}